module.exports = __webpack_public_path__ + "static/media/cliente-cacb.d47f4861.webp";